// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles'

const styles = {
	spinner: {
		boxSizing: 'border-box',
		width: '64px',
		height: '64px',
		borderRadius: '100%',
		border: '8px solid #d6d8db',
		borderTopColor: '#303c49',
		animation: 'spin 0.75s infinite linear',
		margin: '0px auto'
	},
	label: {
		marginTop: "15px",
		textAlign: "center",
		fontFamily: "MANEurope, Arial, sans-serif",
		fontSize: "15px",
		lineHeight: "22px",
		fontStyle: "normal",
		fontWeight: 300,
		color: "#303c49"
	}
};

export const Spinner = withStyles(styles)(({ classes, label }) => (
	<div
		style={{
			flexGrow: 1,
			padding: '75px 35px'
		}}
	>
		<div className={classes.spinner} />
		{label && (
			<div className={classes.label}>{label}</div>
		)}
	</div>
));

Spinner.propTypes = {
	label: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/tco/components/spinner.js